





























































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {FaturamentoCollection} from '@/model/collection/FaturamentoCollection'
import {ListFaturamentoSchema} from '@/schema/resource/Faturamento/ListFaturamentoSchema'
import {CsvFaturamentoSchema} from '@/schema/resource/Faturamento/CsvFaturamentoSchema'
import FilterToggle from '@/components/FilterToggle.vue'
import FaturamentoFilter from '@/components/filters/FaturamentoFilter.vue'
import {FaturamentoFilterCollection} from '@/model/filter/FaturamentoFilterCollection'
@Component({
  components: {FaturamentoFilter, FilterToggle},
})
export default class ListFaturamentoView extends Mixins(MixinQueryRouter) {
  schema = new ListFaturamentoSchema()
  collection = new FaturamentoFilterCollection()
  filterOpen = false

  async created() {
    this.collection.orderBy = 'dataGeracaoFaturamento'
    this.collection.asc = false
    await this.collection.queryAsPage()
  }

  async downloadXlsx() {
    const {params} = this.collection
    delete params.page
    delete params.limit

    params.orderBy = 'dataGeracaoFaturamento'
    params.ascending = false

    const xlsx = new FaturamentoCollection().clearFilters().addFilter(params)

    await xlsx.listCsvFaturamento()
    this.$xlsx.downloadFromSchema(
      xlsx.all(),
      new CsvFaturamentoSchema(),
      $.t('schema.ListFaturamento.title') as string,
      false
    )
  }
}
